module.exports = __webpack_public_path__ + "media/whats_your_status_series_your_college_application/make-the-most-of-your-college-application-d0084c09.jpg";